import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    TextField,
    DialogActions
} from "@material-ui/core";
import {connect} from "react-redux";
import {LOGIN_START, LOGIN_STARTED} from "../../../actions";
import LinearProgress from "@material-ui/core/LinearProgress";

const style = theme => ({
    root: {
        width: '100%'
    }

});

class LoginPanel extends Component {
    state = {
        username: '',
        password: ''
    };

    handleChange = (name, event) => {
        const newState = {};
        newState[name] = event.target.value;
        this.setState(newState);
    };

    handleSubmit = () => {
        const foo = this.props.login(this.state.username, this.state.password);
        console.log(foo);
    };

    render() {

        const progress = LOGIN_STARTED === this.props.loginStatus ? <LinearProgress /> : null;
        let error = null;
        if (this.props.loginError) {
            console.log(this.props.loginError);
            error = <DialogContentText color="error">{this.props.loginError}</DialogContentText>;
        }

        return (
            <Dialog open={true} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Login</DialogTitle>
                <DialogContent>
                    {progress}
                    {error}
                    <DialogContentText>
                        You must first login to access the admin console
                    </DialogContentText>
                    <TextField autoFocus margin="normal" id="username" label="Username" type="text" fullWidth={true} value={this.state.username} onChange={(e) => this.handleChange('username', e)} />
                    <TextField margin="normal" id="password" label="Password" type="password" fullWidth={true} value={this.state.password} onChange={(e) => this.handleChange('password', e)} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleSubmit()} color="primary">Submit</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loginError: state.root.loginError,
        loginStatus: state.root.loginStatus
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        login: (username, password) => dispatch({type: LOGIN_START, username: username, password: password})
    };
};

export default withStyles(style)(connect(mapStateToProps, mapDispatchToProps)(LoginPanel));